export default "/images/arm_swis_bank.png?19959f101dd63fb25782e64fffa86e93";